import { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Send, Loader2 } from 'lucide-react';
import api from '@/lib/apiClient';
import { showAlert } from '@/components/ui/GlobalAlert';

const inputClass = "w-full bg-white/[0.04] border border-[rgba(201,164,76,0.15)] text-[#F8F6F0] placeholder-[#B8B8B8]/40 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[#C9A44C] focus:ring-1 focus:ring-[#C9A44C]/50 transition-all duration-300";

export default function ContactSection() {
  const [form, setForm] = useState({ nombre: '', email: '', asunto: '', mensaje: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/api/contacto', form);
      showAlert('Mensaje enviado. Te responderemos a la brevedad.', 'success');
      setForm({ nombre: '', email: '', asunto: '', mensaje: '' });
    } catch (err) {
      showAlert(err.response?.data?.detail || 'No se pudo enviar el mensaje. Intentá nuevamente.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contacto" className="relative py-20 lg:py-28 bg-[#050505]" data-testid="contact-section">
      <div className="max-w-2xl mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl lg:text-[2.2rem] font-medium text-[#F8F6F0] tracking-tight mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
              Contacto y <span className="text-[#C9A44C] italic">soporte</span>
            </h2>
            <p className="text-[#B8B8B8] text-sm max-w-md mx-auto leading-relaxed">
              Consultas, sugerencias o reclamos: escribinos y te respondemos directo a tu correo.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
            <div className="grid sm:grid-cols-2 gap-4">
              <input type="text" name="nombre" placeholder="Nombre" className={inputClass} value={form.nombre} onChange={handleChange} required minLength={2} data-testid="contact-nombre-input" />
              <input type="email" name="email" placeholder="Tu email" className={inputClass} value={form.email} onChange={handleChange} required data-testid="contact-email-input" />
            </div>
            <input type="text" name="asunto" placeholder="Asunto (opcional)" className={inputClass} value={form.asunto} onChange={handleChange} data-testid="contact-asunto-input" />
            <textarea name="mensaje" placeholder="Tu mensaje" rows={5} className={`${inputClass} resize-none`} value={form.mensaje} onChange={handleChange} required minLength={5} data-testid="contact-mensaje-input" />

            <button type="submit" disabled={loading}
              className="group w-full sm:w-auto text-[#050505] px-8 py-3.5 rounded text-sm font-bold transition-all duration-300 flex items-center justify-center gap-2 hover:shadow-[0_0_35px_rgba(201,164,76,0.4)] disabled:opacity-60"
              style={{ background: 'linear-gradient(135deg, #C9A44C, #E0C878)' }}
              data-testid="contact-submit-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
              Enviar mensaje
            </button>
          </form>

          <div className="mt-8 flex items-center justify-center gap-2 text-[#B8B8B8]/60 text-xs">
            <Mail className="w-3.5 h-3.5" />
            <a href="mailto:contacto@lexorbit.com.ar" className="hover:text-[#C9A44C] transition-colors">contacto@lexorbit.com.ar</a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
